import React from "react";
import { Route, Redirect, withRouter } from "react-router-dom";

const PrivateRoute = ({ component: Component, path, ...rest }) => {
  const isUserLoggedIn = (isAuthenticated, isShutterbAuthenticated) => {
    return isAuthenticated || isShutterbAuthenticated;
  };

  return (
    <Route
      {...rest}
      exact
      // eslint-disable-next-line no-nested-ternary
      render={(props) =>
        isUserLoggedIn(rest.isAuthenticated, rest.isShutterbAuthenticated) ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        )
      }
    />
  );
};

export default withRouter(PrivateRoute);
